import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import general from "./modules/general";
import post from "./modules/post";
import offer from "./modules/offer";
import giftCard from "./modules/gift-card";
import domex from "./modules/domex";
import sante from "./modules/sante";

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== "production",
  modules: {
    general,
    post,
    offer,
    giftCard,
    domex,
    sante,
  },
});
